module.exports = __webpack_public_path__ + "static/shotlists_shots-7613e506dcae9cbe195bb8a268512b1b.png";